import { Crown, ShieldCheck, Users } from 'lucide-react'

import { BlacklineLogoMark } from '@/features/marketing/components/BlacklineLogoMark'
import { MOCK_SQUADRON } from '@/features/marketing/mockData/squadron'

/**
 * Squadron header card mockup — mirrors the visual treatment of the
 * real squadron Dashboard hero. Used as the ambient mockup on the
 * Squadrons explore page hero.
 */
export function SquadronHeaderMockup() {
  const sq = MOCK_SQUADRON
  const memberPct = Math.min(100, (sq.memberCount / sq.memberCap) * 100)
  return (
    <div className="flex flex-col gap-4 p-6">
      <div className="flex items-start gap-4">
        <BlacklineLogoMark size={64} className="shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-display truncate text-xl font-black text-fg">
              {sq.name}
            </h3>
            {sq.squadronVerified && (
              <span
                className="font-display inline-flex items-center gap-1 rounded-md border border-primary/30 bg-primary/10 px-1.5 py-0.5 text-[10px] font-bold tracking-[0.15em] text-primary uppercase"
                title="Verified squadron"
              >
                <ShieldCheck className="size-2.5" aria-hidden />
                Verified
              </span>
            )}
          </div>
          <p className="mt-1 text-xs text-fg-muted line-clamp-2">
            {sq.description}
          </p>
          <div className="mt-3 flex items-center gap-2">
            <span className="font-display inline-flex items-center gap-1 rounded-md border border-warning/40 bg-warning/10 px-1.5 py-0.5 text-[10px] font-bold tracking-[0.15em] text-warning uppercase">
              <Crown className="size-2.5" aria-hidden />
              {sq.tierLabel} tier
            </span>
          </div>
        </div>
      </div>

      {/* Member-cap bar — bigger, vertical layout. */}
      <div>
        <div className="font-display flex items-center justify-between text-[10px] tracking-[0.15em] text-fg-muted uppercase">
          <span className="inline-flex items-center gap-1.5">
            <Users className="size-3" aria-hidden />
            Members
          </span>
          <span className="text-fg">
            {sq.memberCount} / {sq.memberCap}
          </span>
        </div>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-border">
          <div
            className="h-full rounded-full bg-gradient-to-r from-primary to-secondary"
            style={{ width: `${memberPct}%` }}
          />
        </div>
        <p className="font-display mt-2 text-[10px] tracking-[0.15em] text-fg-subtle uppercase">
          Room for {sq.memberCap - sq.memberCount} more
        </p>
      </div>
    </div>
  )
}
